import React, { CSSProperties } from 'react';
import { Card, CardProps } from 'antd';

/**
 * Custom Card wrapper with modern styling
 */
export interface MyCardProps extends Omit<CardProps, 'variant'> {
  cardVariant?: 'default' | 'bordered' | 'elevated' | 'gradient';
  shadow?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
}

const MyCard: React.FC<MyCardProps> = ({
  cardVariant = 'default',
  hoverable = false,
  shadow = 'md',
  style,
  className,
  children,
  ...rest
}) => {
  // Shadow levels
  const shadows: Record<string, string> = {
    none: 'none',
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  };

  // Variant styles
  const variantStyles: Record<string, CSSProperties> = {
    default: {
      background: '#fff',
      border: '1px solid #f0f0f0',
    },
    bordered: {
      background: '#fff',
      border: '2px solid #1890ff',
    },
    elevated: {
      background: '#fff',
      border: 'none',
    },
    gradient: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      border: 'none',
      color: '#fff',
    },
  };

  const customStyle: CSSProperties = {
    ...variantStyles[cardVariant],
    boxShadow: shadows[shadow],
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    ...style,
  };

  const hoverStyle: CSSProperties = hoverable
    ? {
        cursor: 'pointer',
      }
    : {};

  return (
    <Card
      hoverable={hoverable}
      style={{ ...customStyle, ...hoverStyle }}
      className={className}
      {...rest}
    >
      {children}
    </Card>
  );
};

export default MyCard;
